import { Injectable, inject } from '@angular/core';
import Config from '../utils/config.service';

@Injectable({ providedIn: 'root' })
export default class ProfilePictureService {
	private config: Config = inject(Config);
	
	getProfilePictureUrl(user) {
		if (user) {
			if (user.fileUrl) {
				return user.fileUrl;
			} else {
				if (user.profile && (user.profile.fileUrl || user.profile.id)) {
					return (user.profile.fileUrl ? user.profile.fileUrl : this.config.getRestUrl() + "rest/post/picture/raw/" + user.profile.id);
				} else {
					if (user.profilePicture) {
						if (user.profilePicture.fileUrl || user.profilePicture.thumbnailUrl) {
							return user.profilePicture.fileUrl || user.profilePicture.thumbnailUrl;
						} else {
							return this.config.getRestUrl() + "rest/post/picture/thumbnail/" + user.profilePicture.id;
						}
					} else {
						if (user.pictureUuid || user.fileUrl) {
							if (user.fileUrl && user.fileUrl.length > 0) {
								return user.fileUrl;
							} else {
								return this.config.getRestUrl() + 'rest/image/USER/' + user.pictureUuid;
							}
						} else {
							if (user.businessUserType === 'SERVICE_PROVIDER') {
								return 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/avatar-01.svg';
							} else {
								if (user.origin == 'siffi.com') {
									return "https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/default_profile_picture_siffi_green.png";
								} else if (user.previsitUser == true) {
									return "https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/default_profile_picture_previsit2.png";
								} else {
									return "https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/default_profile_picture.png";
								}
							}
						}
					}
				}
			}
		}
	}
	
	getChatBotPictureUrl(origin) {
		if (origin === 'minudoc.ee') {
			return 'https://dqs3afosyxqoy.cloudfront.net/assets/shared/chatbot-minudoc.png';
		} else {
			return 'https://dqs3afosyxqoy.cloudfront.net/assets/shared/chatbot-siffi.png';
		}
	}
	
	getCoverPictureUrl(user) {
		if (user) {
			if (user.cover) {
				return (user.cover.fileUrl ? user.cover.fileUrl : this.config.getRestUrl() + "rest/post/picture/raw/" + user.cover.id);
			} else {
				if (user.coverPicture) {
					if (user.coverPicture.fileUrl) {
						return user.coverPicture.fileUrl;
					} else {
						return this.config.getRestUrl() + "rest/post/picture/raw/" + user.coverPicture.id;
					}
				} else {
					if (user.coverUuid || user.coverFileUrl) {
						if (user.coverFileUrl && user.coverFileUrl.length > 0) {
							return user.coverFileUrl;
						} else {
							return this.config.getRestUrl() + 'rest/image/USER' + user.pictureUuid;
						}
					} else {
						var parent: any = user.parentBusinessUser;
						if (user.businessUserType === 'SERVICE_PROVIDER' && parent && parent.coverPicture) {
							if (parent.coverPicture && parent.coverPicture.fileUrl) return parent.coverPicture.fileUrl;
						}
						
						return "https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/default_profile_cover.jpg";
					}
				}
			}
		} else {
			return "https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/default_profile_cover.jpg";
		}
	}
	
	getCoverThumbnailUrl(user) {
		if (user) {
			if (user.cover) {
				if (user.cover.thumbnailUrl) {
					return user.cover.thumbnailUrl;
				} else if (user.cover.fileUrl) {
					return user.cover.fileUrl;
				} else {
					return (this.config.getRestUrl() + "rest/post/picture/raw/" + user.cover.id);
				}
			} else {
				if (user.coverPicture) {
					if (user.coverPicture.fileUrl) {
						return user.coverPicture.fileUrl;
					} else {
						return this.config.getRestUrl() + "rest/post/picture/raw/" + user.coverPicture.id;
					}
				} else {
					if (user.coverUuid || user.coverFileUrl) {
						if (user.coverFileUrl && user.coverFileUrl.length > 0) {
							return user.coverFileUrl;
						} else {
							return this.config.getRestUrl() + 'rest/image/USER' + user.pictureUuid;
						}
					} else {
						return "https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/default_profile_cover.jpg";
					}
				}
			}
		} else {
			return "https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/default_profile_cover.jpg";
		}
	}
	
	getProfileThumbnailUrl(user) {
		if (user) {
			if (user.profilePicture) {
				if (user.profilePicture.thumbnailUrl) {
					return user.profilePicture.thumbnailUrl;
				} else {
					if (user.origin == 'siffi.com') {
						return "https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/default_profile_picture_siffi_green.png";
					} else if (user.previsitUser == true) {
						return "https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/default_profile_picture_previsit2.png";
					} else {
						return "https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/default_profile_picture.png";
					}
				}
			} else {
				if (user.origin == 'siffi.com') {
					return "https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/default_profile_picture_siffi_green.png";
				} else if (user.previsitUser == true) {
					return "https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/default_profile_picture_previsit2.png";
				} else {
					return "https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/default_profile_picture.png";
				}
			}
		}
	}
	
	getProfileCoverThumbnailUrl(user) {
		if (user) {
			if (user.coverPicture) {
				if (user.coverPicture.thumbnailUrl) {
					return user.coverPicture.thumbnailUrl;
				} else {
					return "https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/default_profile_cover.jpg";
				}
			} else {
				return "https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/default_profile_cover.jpg";
			}
		}
	}
	
}